import axiosClient from "../utils/axios";

export default function ({
  address,
  page,
  limit,
}: {
  address: string;
  page: number;
  limit: number;
}) {
  return axiosClient
    .get(`/lend-orders/ordersByWalletAddress`, {
      params: {
        walletAddress: address,
        limit: limit,
        page: page + 1,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}
